import React from 'react';
export function WeekByWeekSection() {
  const weeks = [{
    number: '01',
    title: 'Auditoría y Desarme',
    description: 'Evaluamos la situación real sin juzgar. Aprenderás a detener el ciclo de peleas y a usar frases específicas que bajan las defensas de tu adolescente instantáneamente.'
  }, {
    number: '02',
    title: 'Reconstruyendo el Puente',
    description: 'Estrategias prácticas para entrar en su mundo digital. Cómo mostrar interés genuino para que ellos vuelvan a mostrar interés en el mundo real y en la familia.'
  }, {
    number: '03',
    title: 'Límites Colaborativos',
    description: "El paso a paso para crear un 'Acuerdo de Uso de Pantallas' juntos. Cuando ellos participan en la creación de las reglas, es mucho más probable que las respeten."
  }, {
    number: '04',
    title: 'Mantenimiento y Alternativas',
    description: 'Qué hacer cuando rompen las reglas (porque lo harán). Cómo aplicar consecuencias lógicas sin enojo y cómo fomentar pasatiempos offline de manera natural.'
  }];
  return <section className="bg-alternate py-10 md:py-24 px-4" data-id="element-225">
      <div className="max-w-5xl mx-auto" data-id="element-226">
        <div className="text-center mb-10 md:mb-16" data-id="element-227">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-228">
            Un vistazo dentro de la guía: El plan de 4 semanas
          </h2>
          <p className="text-base md:text-lg text-text-secondary max-w-2xl mx-auto" data-id="element-229">
            Estructurado paso a paso para que no te sientas abrumada. Solo lee
            el capítulo correspondiente y aplica la acción de la semana.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10" data-id="element-230">
          {weeks.map((week, index) => <div key={index} className="flex gap-4 md:gap-6 p-5 md:p-6 rounded-2xl bg-primary border border-border" data-id="element-231">
              <div className="flex-shrink-0" data-id="element-232">
                <span className="text-3xl md:text-5xl font-heading font-bold text-trust/20" data-id="element-233">
                  {week.number}
                </span>
              </div>
              <div data-id="element-234">
                <h3 className="text-lg md:text-xl font-bold text-text-primary mb-1.5 md:mb-2" data-id="element-235">
                  Semana {parseInt(week.number)}: {week.title}
                </h3>
                <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-236">
                  {week.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}